import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { label: 'Who We Are', path: '/' },
      { label: 'What We Do', path: '/what-we-do' },
      { label: 'Leadership', path: '/#leadership' }
    ],
    services: [
      { label: 'Engage With Us', path: '/engage' },
      { label: 'Partner With Us', path: '/partner' },
      { label: 'Investment Opportunities', path: '/partner#investment' }
    ],
    contact: [
      { label: 'Connect With Us', path: '/connect' },
      { label: 'Careers', path: '/partner#careers' },
      { label: 'Media Relations', path: '/connect#media' }
    ]
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_xcelsior-web/artifacts/ye9jrchw_Screenshot_20251201-140847.jpg" 
                alt="XSI Logo" 
                className="h-14 w-auto rounded"
              />
            </div>
            <p className="text-gray-400 mb-4">
              Engineering Africa's sustainable ascent through innovation, ESG, and strategic partnerships.
            </p>
            <Link to="/explore/our-story" className="text-[#00CED1] font-semibold italic text-lg hover:underline underline-offset-4" data-testid="footer-tagline-link">
              Ascende Superius
            </Link>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Company
            </h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path} 
                    className="text-gray-400 hover:text-[#00CED1] transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Services
            </h3>
            <ul className="space-y-3">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path} 
                    className="text-gray-400 hover:text-[#00CED1] transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Contact
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-gray-400">
                <MapPin className="w-5 h-5 text-[#00CED1] mt-1 flex-shrink-0" />
                <span className="text-sm">6 Everett Close, Mount Pleasant, Harare, Zimbabwe</span>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Mail className="w-5 h-5 text-[#00CED1] flex-shrink-0" />
                <a href="mailto:info@xsi.co.zw" className="hover:text-[#00CED1] transition-colors text-sm">
                  info@xsi.co.zw
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-400">
                <Phone className="w-5 h-5 text-[#00CED1] flex-shrink-0 mt-1" />
                <div className="flex flex-col text-sm">
                  <a href="tel:+263717802657" className="hover:text-[#00CED1] transition-colors">+263 717 802 657</a>
                  <a href="tel:+263774806743" className="hover:text-[#00CED1] transition-colors">+263 774 806 743</a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Xcelsior Strategies International. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="https://xsi.co.zw" className="text-gray-400 hover:text-[#00CED1] transition-colors text-sm">
                xsi.co.zw
              </a>
              <a href="https://xcelsior.co.zw" className="text-gray-400 hover:text-[#00CED1] transition-colors text-sm">
                xcelsior.co.zw
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;